/**
 * Раздел «Наставник» — вкладки внутри одного раздела нижней панели.
 *
 * Показатели (S8), цели роста и микроурок (S11), тренировки (S10) — стороны
 * одного наставника (§10.8): цифры говорят, где отстаёшь, цель — куда
 * расти, микроурок и тренировка — как. Отдельными разделами панели они
 * вытеснили бы справочник, ради которого официант открывает приложение у
 * стола (D93), поэтому живут вкладками, тем же приёмом, что «Редактор».
 */

import { useState } from 'react';
import { Button } from '@shell/ui';
import { Goals } from './Goals';
import { Mentor } from './Mentor';
import { Micro } from './Micro';
import { Roleplay } from './Roleplay';

const TABS = [
  { code: 'metrics', title: 'Показатели' },
  { code: 'goals', title: 'Цели' },
  { code: 'micro', title: 'Микроурок' },
  { code: 'roleplay', title: 'Тренировка' },
] as const;

type Tab = (typeof TABS)[number]['code'];

export function MentorHome() {
  const [tab, setTab] = useState<Tab>('metrics');

  return (
    <>
      <div className="editor-tabs" role="tablist">
        {TABS.map((item) => (
          <Button
            key={item.code}
            small
            variant={tab === item.code ? 'primary' : 'quiet'}
            onClick={() => setTab(item.code)}
          >
            {item.title}
          </Button>
        ))}
      </div>

      {tab === 'metrics' && <Mentor />}
      {tab === 'goals' && <Goals />}
      {tab === 'micro' && <Micro />}
      {tab === 'roleplay' && <Roleplay />}
    </>
  );
}
